import gql from 'graphql-tag';

import { NOTIFICATION_ACTIVITY_FRAGMENT } from '../fragments/Notification/notificationActivity';

export const GET_NOTIFICATION_ACTIVITY_SUBSCRIPTION = gql`
  subscription GetNotificationActivity {
    notificationActivity {
      ...notificationActivity
      totalUnreadCount
    }
  }
  ${NOTIFICATION_ACTIVITY_FRAGMENT}
`;
